"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var CmsBannersRouteListCtl = /** @class */ (function (_super) {
    __extends(CmsBannersRouteListCtl, _super);
    function CmsBannersRouteListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_priority = UIUtils_1.UIUtils.IProp2Str(function (o) { o.priority; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_route_template = UIUtils_1.UIUtils.IProp2Str(function (o) { o.route_template; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    CmsBannersRouteListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    CmsBannersRouteListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "object with id [" + id + "] not found !";
    };
    CmsBannersRouteListCtl.prototype.LoadData = function (allBrands, brandsIdList, onDone) {
        var _this = this;
        webAApi_1.ListBannersRoutesByBrandIdGet.exec({ all_brands: allBrands, brand_id_list: brandsIdList }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    title: resp.list[i].title,
                    priority: resp.list[i].priority,
                    route_template: resp.list[i].route_template,
                    is_locked: resp.list[i].is_locked,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CmsBannersRouteListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBannerRoute.exec({
            data: {
                brand_id: data.brand_id,
                title: data.title,
                route_template: data.route_template,
                is_locked: data.is_locked,
                priority: data.priority
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed2: moment(resp.date_added_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                title: data.title,
                priority: data.priority,
                brand_id: data.brand_id,
                brand_title: resp.brand_title,
                route_template: data.route_template,
                is_locked: data.is_locked
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CmsBannersRouteListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBannerRoute.exec({
                data: {
                    banner_route_id: data.key,
                    title: data.title,
                    route_template: data.route_template,
                    is_locked: data.is_locked,
                    priority: data.priority
                }
            }, function (resp) {
                _tmp.title = data.title;
                _tmp.route_template = data.route_template;
                _tmp.is_locked = data.is_locked;
                _tmp.priority = data.priority;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CmsBannersRouteListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    CmsBannersRouteListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBannerRoute.exec({ data: { banner_route_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CmsBannersRouteListCtl.prototype.SetIsLocked = function (bannerUrlId, IsLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(bannerUrlId);
        if (_tmp) {
            webAApi_1.DoSetBannerRouteIsLocked.exec({
                data: {
                    banner_url_id: bannerUrlId,
                    is_locked: IsLocked
                }
            }, function (resp) {
                _tmp.is_locked = IsLocked;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CmsBannersRouteListCtl.prototype.SetPriority = function (bannerUrlId, Priority, onDone) {
        var _this = this;
        var _tmp = this.getById(bannerUrlId);
        if (_tmp) {
            webAApi_1.DoSetBannerRoutePriority.exec({
                data: {
                    banner_url_id: bannerUrlId,
                    priority: Priority
                }
            }, function (resp) {
                _tmp.priority = Priority;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return CmsBannersRouteListCtl;
}(BaseController_1.BaseController));
exports.CmsBannersRouteListCtl = CmsBannersRouteListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_banners/ctl/CmsBannersRouteListCtl.ts
// module id = 947
// module chunks = 0